import { Injectable } from "@angular/core";
import { BASEMysqlService } from "./_base";
@Injectable({
  providedIn: 'root'
})
export class MysqlServiceUtentiCorsi extends BASEMysqlService {

  prefix = 'utenti_corsi_'

  //////////////////////////////////////////////////////////////////////////////////////////

  list(filter?): Promise<any> {
    let data = {
      auth: this.getAuth(),
      filter: filter
    }

     console.log(data)

    return this.http.post(this.URL_BASE + this.prefix + 'list', data).toPromise();
  }

  get(id): Promise<any> {
    let data = {
      auth: this.getAuth(),
      id: id
    }

    // console.log(data)

    return this.http.post(this.URL_BASE + this.prefix + 'get', data).toPromise();
  }

  upsert(item: any): Promise<any[]> {
    let data = {
      auth: this.getAuth(),
      item: item
    }

    return this.http.post<any[]>(this.URL_BASE + this.prefix + 'upsert', data).toPromise();
  }

  delete(id: number): Promise<any> {
    let data = {
      auth: this.getAuth(),
      id: id
    }

    return this.http.post(this.URL_BASE + this.prefix + 'delete', data).toPromise();
  }

  report(id){
    let url = this.URL_BASE + this.prefix + 'report&id=' + id;
    return url;
  }

}